<template>
    <v-container fluid class="pa-0">
    <v-card>
        <v-card-title>{{$t('event.speaker')}}</v-card-title>
        <v-card-text>
        <v-form ref="form" v-model="isFormValid">
                <v-row>
                    <v-col class="pb-0">
                        <v-text-field outlined
                            :label="$t('event_speaker.type')"
                            :placeholder="$t('event_speaker.type')"
                            v-model="eventSpeaker.type"
                            type="number"
                            :rules="[value => !!value || 'Required']"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="pb-0">{{$t('event_speaker.html_content')}}</v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <froala
                            v-if="showEditor"
                            :config="froalaConfig"
                            v-model="eventSpeaker.html_content"
                        ></froala>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-btn color="primary" @click="saveEventSpeaker" :disabled="!isFormValid">
                            {{$t('save')}}
                        </v-btn>
                    </v-col>
                </v-row>
        </v-form>

        </v-card-text>
    </v-card>

    <v-row v-if="speakerId">
        <v-col>
            <EventSpeakerItemList :speaker-id="speakerId"></EventSpeakerItemList>
        </v-col>
    </v-row>

    </v-container>
</template>

<script>
    import {computed, ref} from '@vue/composition-api'
    import {useGet} from "feathers-vuex";
    import EventSpeakerItemList from "./EventSpeakerItemList";
    import froalaConfig from "../../froala-config";

    export default {
        name: 'EventSpeaker',
        components: {EventSpeakerItemList},
        setup(props, {root}) {
            const {Event, EventSpeaker} = root.$FeathersVuex.api;

            const showEditor = ref(false);

            const eventId = computed(() => root.$route.params.eventId);
            const {item: event, isPending} = useGet({model: Event, id: eventId});

            const eventSpeaker = computed(() => {
                return event.value ? event.value.f_speaker : null;
            });

            const speakerId = computed(() => {
                return eventSpeaker.value && !eventSpeaker.value.__isTemp ? eventSpeaker.value.id : null;
            });

            const isFormValid = ref(false);

            const saveEventSpeaker = async function () {
                eventSpeaker.value.save().then(() => {
                    root.$store.dispatch('showSnackBar', root.$t('event_speaker.save_successful'));
                }, root.$handleFeatherError.bind(root));
            };

            return {
                eventSpeaker,
                speakerId,

                isFormValid,
                saveEventSpeaker,

                froalaConfig: {
                    ...froalaConfig,
                    toolbarSticky: false
                },
                showEditor,
            }
        },
        mounted() {
            setTimeout(() => {
               this.showEditor = true;
            }, 100);
        }
    }
</script>